<template>
  <input type="text" ref="input-number" :value="modelValue" @change="(e) => changeInput(e)" />
</template>

<script>
export default {
  name: 'AppInputNumber',
  props: {
    modelValue: [Number, String],
    max: Number,
    min: Number,
    dataType: {
      type: String,
      default: 'int',
      validator: (value) => {
        return ['int', 'float'].indexOf(value) !== -1;
      },
    },
    decimal: {
      type: Number,
      default: 2,
      validator: (value) => {
        return value >= 0;
      },
    },
  },

  mounted() {
    const textbox = this.$refs['input-number'];
    [
      'input',
      'keydown',
      'keyup',
      'keypress',
      'mousedown',
      'mouseup',
      'select',
      'contextmenu',
      'drop',
    ].forEach((event) => {
      textbox.addEventListener(event, () => {
        if (this.testData(textbox.value)) {
          textbox.oldValue = +textbox.value;
          textbox.oldSelectionStart = +textbox.selectionStart;
          textbox.oldSelectionEnd = +textbox.selectionEnd;
          /* eslint-disable */
        } else if (textbox.hasOwnProperty('oldValue')) {
          textbox.value = +textbox.oldValue;
          textbox.setSelectionRange(+textbox.oldSelectionStart, +textbox.oldSelectionEnd);
        } else {
          textbox.value = '';
        }
      });
    });
  },

  methods: {
    changeInput($event) {
      const inputValue = this.$refs['input-number'].value;
      if (!this.testData(inputValue)) {
        $event.preventDefault();
      } else {
        this.$emit('update:modelValue', +inputValue);
      }
    },

    testData(value) {
      // Integer
      if (this.dataType === 'int') {
        if (this.max) {
          return /^\d*$/.test(value) && (value === '' || parseInt(value, 10) <= this.max);
        }
        return /^\d*$/.test(value);
      }
      // Float
      if (this.decimal > 0) {
        const reg = new RegExp('^-?\\d*[.]?\\d{0,' + this.decimal + '}$');
        return reg.test(value) && (value === '' || parseFloat(value) <= this.max);
      }
      return /^-?\d*[.]?\d*$/.test(value);
    },
  },
};
</script>

<style></style>
